import { useAppContext } from './AppContext'

export const useSubscriptionConfig = () => {
  const { blogFeatureConfigData } = useAppContext();
  const subscriptionItem = blogFeatureConfigData?.find((item: any) => item?.feature?.feature_key === "enable_blog_subscription")
  const subscriptionConfig = subscriptionItem
    ? subscriptionItem?.feature?.configuration?.value[0]?.value === 'true'
      ? true
      : false
    : false;

  return subscriptionConfig;
}